 <template>
  <div class="download-page">
    <!-- 整屏模块 -->
    <div
      v-for="(item, index) in sections"
      :key="item.key"
      class="fullscreen-section reveal-section"
      :class="[item.className, { 'is-visible': visibleMap[index] }]"
    >
      <div class="section-canvas" :style="{ transform: 'scale(' + scale + ')' }">
        <div class="section-inner">

          <!-- 模块一：灰色背景 -->
          <div v-if="item.key === 'hero'" class="mod1-layout">
            <!-- 左侧文字区 -->
            <div class="mod1-text">
              <h2 class="mod1-title">{{ $t('download.title') }}</h2>
              <div class="mod1-subtitle">{{ $t('download.subtitle') }}</div>
              <p class="mod1-desc">{{ $t('download.desc') }}</p>
            </div>
            <!-- 左下角二维码 -->
            <div class="mod1-chapp">
              <img class="mod1-chapp-img" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-1-INTAPP.png') : require('../assets/images/download/download-1-CHAPP.png')" alt="下载二维码">
            </div>
            <!-- 二维码提示文字 -->
            <div class="mod1-chapp-tip">{{ $t('download.scanTip') }}</div>
            <img class="mod1-phone" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-1-INTphone.png') : require('../assets/images/download/download-1-phone.png')" alt="">
            <!-- 手机端下载按钮（桌面端隐藏） -->
            <a class="mod1-download-btn" href="https://app-download.szcofoe.com/#/appstore" target="_blank" rel="noopener">{{ $t('download.downloadBtn') }}</a>
          </div>

          <!-- 模块二：白色背景 -->
          <div v-if="item.key === 'intro'" class="mod2-layout">
            <div class="mod2-header">
              <h2 class="mod2-title">{{ $t('download.mod2Title') }}</h2>
              <div class="mod2-divider"></div>
              <p class="mod2-subtitle">{{ $t('download.mod2Subtitle') }}</p>
            </div>
            <div class="mod2-cols">
              <div class="mod2-col-center">
                <img class="mod2-phone" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-INTphone.png') : require('../assets/images/download/download-2-phone.png')" alt="">
              </div>
              <div class="mod2-col-right">
                <div class="mod2-text mod2-text-3">{{ stripNewlines($t('download.feature2')) }}</div>
                <img class="mod2-card-3" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-3INT.png') : require('../assets/images/download/download-2-3.png')" alt="">
                <div class="mod2-text mod2-text-2">{{ stripNewlines($t('download.feature3')) }}</div>
                <img class="mod2-card-2" :src="$i18n.locale === 'en' ? require('../assets/images/download/download-2-2INT.png') : require('../assets/images/download/download-2-2.png')" alt="">
              </div>
            </div>
          </div>

          <!-- 模块三：灰色背景 -->
          <div v-if="item.key === 'feature'" class="mod3-layout">
            <h2 class="mod3-title">{{ $t('download.mod3Title') }}</h2>
            <div class="mod3-divider"></div>
            <p class="mod3-subtitle">{{ $t('download.mod3Subtitle') }}</p>
            <div class="mod3-list">
              <div
                v-for="(card, index) in mod3Cards"
                :key="index"
                class="mod3-card"
                :class="{ active: activeCard === index }"
                @mouseenter="activeCard = index"
              >
                <img class="mod3-card-bg" :src="card.bg" alt="">
                <div class="mod3-card-title">{{ card.title }}</div>
                <div class="mod3-card-subtitle">{{ activeCard === index ? card.subtitle.replace(/\n/g, '') : card.subtitle }}</div>
                <!-- 详情面板（仅激活卡片显示） -->
                <img v-if="activeCard === index" class="mod3-panel" :src="card.panel" alt="">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'DownloadPage',
  components: {
    Footer
  },
  data() {
    return {
      scale: 1,
      baseZoom: 1,
      sections: [
        { key: 'hero', className: 'module-hero' },
        { key: 'intro', className: 'module-intro' },
        { key: 'feature', className: 'module-feature' }
      ],
      visibleMap: {},
      observer: null,
      // 模块三当前展开的卡片索引
      activeCard: 0
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 1024
    },
    // 模块三卡片配置
    mod3Cards() {
      const bgList = [
        require('../assets/images/download/download-3-1.png'),
        require('../assets/images/download/download-3-2.png'),
        require('../assets/images/download/download-3-3.png'),
        require('../assets/images/download/download-3-4.png')
      ]
      // 英文版单独切图
      const panelList = this.$i18n.locale === 'en' ? [
        require('../assets/images/download/download-3-panel-1-INT.png'),
        require('../assets/images/download/download-3-panel-2-INT.png'),
        require('../assets/images/download/download-3-panel-3-INT.png'),
        require('../assets/images/download/download-3-panel-4-INT.png')
      ] : [
        require('../assets/images/download/download-3-panel-1.png'),
        require('../assets/images/download/download-3-panel-2.png'),
        require('../assets/images/download/download-3-panel-3.png'),
        require('../assets/images/download/download-3-panel-4.png')
      ]
      return bgList.map((bg, index) => ({
        bg,
        panel: panelList[index],
        title: this.stripNewlines(this.$t('download.mod3CardTitle' + (index + 1))),
        subtitle: this.stripNewlines(this.$t('download.mod3CardSubtitle' + (index + 1)))
      }))
    }
  },
  mounted() {
    this.baseZoom = window.devicePixelRatio || 1
    this.updateScale()
    window.addEventListener('resize', this.updateScale)
    this.initObserver()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    // 手机端去掉 \n，避免被折叠成空格
    stripNewlines(text) {
      return this.isMobile ? text.replace(/\n/g, '') : text
    },
    updateScale() {
      // 扣除安全区，避免内容超出产生黑边
      const style = getComputedStyle(document.documentElement)
      const leftInset = parseFloat(style.getPropertyValue('--safe-left')) || 0
      const rightInset = parseFloat(style.getPropertyValue('--safe-right')) || 0
      const topInset = parseFloat(style.getPropertyValue('--safe-top')) || 0
      const bottomInset = parseFloat(style.getPropertyValue('--safe-bottom')) || 0
      const effectiveWidth = window.innerWidth - leftInset - rightInset
      const effectiveHeight = window.innerHeight - topInset - bottomInset
      const fit = Math.max(effectiveWidth / 1920, effectiveHeight / 1080)
      const zoom = (window.devicePixelRatio || 1) / this.baseZoom
      this.scale = fit * zoom
    },
    initObserver() {
      if (!('IntersectionObserver' in window)) {
        this.sections.forEach((item, index) => {
          this.$set(this.visibleMap, index, true)
        })
        return
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.dataset.index)
          this.$set(this.visibleMap, index, entry.isIntersecting)
        })
      }, {
        threshold: 0.15
      })
      this.$nextTick(() => {
        const els = this.$el.querySelectorAll('.reveal-section')
        els.forEach((el, index) => {
          el.dataset.index = index
          this.observer.observe(el)
        })
      })
    }
  }
}
</script>

<style scoped>
/* 页面公共样式 */
.download-page {
  padding-top: 0;
}

/* 整屏模块 */
.fullscreen-section {
  height: 100vh;
  /* 手机端可见高度 */
  height: var(--app-height, 100vh);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.reveal-section {
  position: relative;
}

/* 设计稿画布 */
.section-canvas {
  position: relative;
  width: 1920px;
  height: 1080px;
  flex-shrink: 0;
  transform-origin: center center;
}

.reveal-section .section-inner {
  position: relative;
  width: 100%;
  height: 100%;
  /* 渐入：仅透明度，隐藏态不设过渡以便重播 */
  opacity: 0;
  will-change: opacity;
}

.reveal-section.is-visible .section-inner {
  opacity: 1;
  transition: opacity 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 模块一 */
.module-hero {
  background: #DEDEDE;
}

.module-hero .mod1-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.module-hero .mod1-phone {
  position: absolute;
  top: 56%;
  right: -90px;
  transform: none;
  height: 900px;
  width: 910px;
  object-fit: contain;
}

.module-hero .mod1-text {
  position: absolute;
  left: 400px;
  top: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* 英文版文字区左移 */
:lang(en) .module-hero .mod1-text {
  left: 360px;
}

.module-hero .mod1-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 50px;
  color: #252525;
  line-height: 1.2;
  margin: 0;
}

.module-hero .mod1-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 38px;
  color: #252525;
  line-height: 1.2;
  margin-top: 24px;
}

.module-hero .mod1-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #868686;
  line-height: 44px;
  max-width: 630px;
  margin: 40px 0 0 0;
  text-align: justify;
}

/* 英文版介绍段落 */
:lang(en) .module-hero .mod1-desc {
  font-size: 22px;
  max-width: 700px;
  transform: translate(0, -30px);
}

.module-hero .mod1-chapp {
  position: absolute;
  left: 400px;
  bottom: 260px;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 24px;
}

/* 英文版二维码左移 */
:lang(en) .module-hero .mod1-chapp {
  left: 360px;
}

/* 二维码 */
.module-hero .mod1-chapp-img {
  display: block;
  width: 108px;
  height: auto;
  object-fit: contain;
}

/* 二维码提示文字 */
.module-hero .mod1-chapp-tip {
  position: absolute;
  left: 421px;
  bottom: 200px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 550;
  font-size: 14px;
  color: #252525;
  line-height: 1.4;
  text-align: center;
  white-space: pre-line;   /* 语言包中的 \n 在此换行 */
}

/* 英文版提示文字左移 */
:lang(en) .module-hero .mod1-chapp-tip {
  left: 372px;
}

/* 手机端下载按钮，桌面隐藏 */
.module-hero .mod1-download-btn {
  display: none;
}

/* 入场动效 */
.reveal-section .mod1-text {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .mod1-text {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.2s,
    transform 1.1s ease 0.2s;
}

/* 二维码白块与提示文字同步入场 */
.reveal-section .mod1-chapp,
.reveal-section .mod1-chapp-tip {
  opacity: 0;
  transform: translateY(30px);
}

.reveal-section.is-visible .mod1-chapp,
.reveal-section.is-visible .mod1-chapp-tip {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 手机图入场，保留 translateY(-50%) 居中基准 */
.reveal-section .mod1-phone {
  opacity: 0;
  transform: translateY(-50%) translateY(30px);
}

.reveal-section.is-visible .mod1-phone {
  opacity: 1;
  transform: translateY(-50%) translateY(0);
  transition: opacity 1.1s ease 0.4s,
    transform 1.1s ease 0.4s;
}

/* 模块二 */
.module-intro {
  background: #FFFFFF;
}

.module-intro .mod2-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.module-intro .mod2-header {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.module-intro .mod2-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 48px;
  color: #252525;
  line-height: 1.2;
  margin: 0 0 20px 0;
}

/* 英文版大标题 */
:lang(en) .module-intro .mod2-title {
  font-size: 36px;
}

/* 标题下方分割线 */
.module-intro .mod2-divider {
  width: 200px;
  height: 1px;
  background-color: #000000;
  margin-bottom: 10px;
}

/* 副标题，pre-line 使 \n 生效 */
.module-intro .mod2-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #868686;
  line-height: 1.6;
  max-width: 1200px;
  margin: 0;
  white-space: pre-line;
}

/* 英文版副标题（仅桌面端） */
@media (min-width: 1025px) {
  :lang(en) .module-intro .mod2-subtitle {
    font-size: 18px;
    max-width: 1400px;
  }
}

.module-intro .mod2-phone {
  position: absolute;
  left: 50%;
  top: 62%;
  transform: translate(-50%, -50%);
  height: 600px;
  width: auto;
  object-fit: contain;
}

/* 功能说明文字框，pre-line 使 \n 生效 */
.module-intro .mod2-text {
  position: absolute;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 1.6;
  max-width: 420px;
  padding: 16px 26px;
  background: #00ADBB;
  border-radius: 12px;
  box-sizing: border-box;
  white-space: pre-line;
}

/* 圆点：固定 1em 宽 + 负外边距，与首行文字对齐 */
.module-intro .mod2-text::before {
  content: '•';
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.module-intro .mod2-text-2 {
  left: 280px;
  top: 550px;
  z-index: 2;
}

.module-intro .mod2-text-3 {
  right: 280px;
  top: 480px;
}

@media (min-width: 1025px) {
  :lang(en) .module-intro .mod2-text-2 {
    top: 490px;
  }

  :lang(en) .module-intro .mod2-text-3 {
    top: 460px;
  }
}

.module-intro .mod2-card-2 {
  position: absolute;
  left: 345px;
  top: 650px;
  width: 360px;
  height: auto;
  z-index: 1;
}

/* 右下截图 */
.module-intro .mod2-card-3 {
  position: absolute;
  right: 300px;
  top: 600px;
  width: 400px;
  height: auto;
}

/* 标题/下划线/小标题入场，延迟 0.3s */
.module-intro .mod2-title,
.module-intro .mod2-divider,
.module-intro .mod2-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-intro.is-visible .mod2-title,
.module-intro.is-visible .mod2-divider,
.module-intro.is-visible .mod2-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.3s,
    transform 1.1s ease 0.3s;
}

/* 模块二入场动效：手机图缩放，截图与文字同步 */
.reveal-section .mod2-phone {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.8);
}

.reveal-section.is-visible .mod2-phone {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 截图与文字同步缩放入场 */
.reveal-section .mod2-card-2,
.reveal-section .mod2-text-2,
.reveal-section .mod2-card-3,
.reveal-section .mod2-text-3 {
  opacity: 0;
  transform: scale(0.8);
}

.reveal-section.is-visible .mod2-card-2,
.reveal-section.is-visible .mod2-text-2,
.reveal-section.is-visible .mod2-card-3,
.reveal-section.is-visible .mod2-text-3 {
  opacity: 1;
  transform: scale(1);
  transition: opacity 1.1s ease 0s,
    transform 1.1s ease 0s;
}

/* 模块三 */
.module-feature {
  background: #F5F5F5;
}

.module-feature .mod3-layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.module-feature .mod3-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 48px;
  color: #252525;
  line-height: 1.2;
  margin: 40px 0 40px 0;
}

:lang(en) .module-feature .mod3-title {
  margin: 60px 0 30px 0;
}

/* 标题下方分割线 */
.module-feature .mod3-divider {
  width: 360px;
  height: 1px;
  background-color: #000000;
  margin-bottom: 16px;
}

/* 副标题 */
.module-feature .mod3-subtitle {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #868686;
  line-height: 1.6;
  max-width: 900px;
  margin: 0 0 70px 0;
  text-align: center;
}

/* 四卡片手风琴布局 */
.module-feature .mod3-list {
  display: flex;
  gap: 26px;
  align-items: stretch;
}

/* 单张卡片 */
.module-feature .mod3-card {
  position: relative;
  width: 200px;
  height: 460px;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.3s ease;
  flex-shrink: 0;
}

/* 激活卡片横向展开 */
.module-feature .mod3-card.active {
  width: 640px;
}

/* 卡片背景图 */
.module-feature .mod3-card-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left;
  transition: filter 0.1s ease;
  z-index: 0;
}

/* 详情面板（仅激活卡片显示） */
.module-feature .mod3-panel {
  position: absolute;
  left: 20px;
  top: 180px;
  width: 260px;
  border-radius: 12px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1;
}

.module-feature .mod3-card.active .mod3-panel {
  opacity: 1;
  transform: translateY(0);
}

/* 四张详情面板位置与尺寸 */
.module-feature .mod3-card:nth-child(1) .mod3-panel {
  left: 38px;
  top: 180px;
  width: 300px;
}
:lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel {
  left: 20px;
  top: 180px;
  width: 300px;
}

/* 卡片2 */
.module-feature .mod3-card:nth-child(2) .mod3-panel {
  left: 38px;
  top: 200px;
  width: 280px;
}
:lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel {
  left: 20px;
  top: 200px;
  width: 280px;
}

/* 卡片3 */
.module-feature .mod3-card:nth-child(3) .mod3-panel {
  left: 38px;
  top: 190px;
  width: 290px;
}
:lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel {
  left: 20px;
  top: 190px;
  width: 300px;
}

/* 卡片4 */
.module-feature .mod3-card:nth-child(4) .mod3-panel {
  left: 38px;
  top: 180px;
  width: 260px;
}
:lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
  left: 20px;
  top: 180px;
  width: 280px;
}

/* 卡片标题 */
.module-feature .mod3-card-title {
  position: absolute;
  left: 0;
  right: auto;
  width: 200px;
  text-align: center;
  top: 35px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-size: 38px;
  color: #FFFFFF;
  line-height: 1.0;
  z-index: 3;
  transition: none;
}

/* 展开态标题左对齐 */
.module-feature .mod3-card.active .mod3-card-title {
  left: 24px;
  right: auto;
  text-align: left;
  transition: none;
}

/* 英文版卡片标题 */
:lang(en) .module-feature .mod3-card-title {
  font-size: 22px;
  max-width: 200px;
  left: 20px;
  right: auto;
  text-align: left;
}

:lang(en) .module-feature .mod3-card.active .mod3-card-title {
  left: 20px;
  text-align: left;
  transition: none;
}

/* 卡片副标题：未激活识别 \n，激活后自然换行 */
.module-feature .mod3-card-subtitle {
  position: absolute;
  left: 28px;
  right: 0;
  top: 90px;
  max-width: 200px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  white-space: pre-line;
  text-align: left;
  z-index: 3;
  transition: none;
}

/* 展开态副标题放宽 */
.module-feature .mod3-card.active .mod3-card-subtitle {
  left: 28px;
  right: auto;
  width: 600px;
  max-width: 540px;
  white-space: normal;
  text-align: left;
  transition: none;
}

/* 英文版副标题 */
:lang(en) .module-feature .mod3-card-subtitle {
  max-width: 160px;
  font-size: 20px;
  left: 20px;
  top: 78px;
  text-align: left;
}

:lang(en) .module-feature .mod3-card.active .mod3-card-subtitle {
  max-width: 520px;
  font-size: 20px;
  left: 20px;
  transition: none;
}

/* 悬停背景提亮 */
.module-feature .mod3-card:hover .mod3-card-bg {
  filter: brightness(1.06);
}

/* 标题/下划线/小标题入场，延迟 0.3s */
.module-feature .mod3-title,
.module-feature .mod3-divider,
.module-feature .mod3-subtitle {
  opacity: 0;
  transform: translateY(30px);
}

.module-feature.is-visible .mod3-title,
.module-feature.is-visible .mod3-divider,
.module-feature.is-visible .mod3-subtitle {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.3s,
    transform 1.1s ease 0.3s;
}

/* 卡片图入场，延迟 0.5s */
.module-feature .mod3-list {
  opacity: 0;
  transform: translateY(30px);
}

.module-feature.is-visible .mod3-list {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 1.1s ease 0.5s,
    transform 1.1s ease 0.5s;
}

/* 页脚 */
.download-page >>> .footer {
  scroll-snap-align: end;
}

/* 移动端 */
@media (max-width: 1024px) {
  .section-canvas {
    transform: none !important;
    width: 100%;
    height: 100%;
  }

  /* 禁止 flex 压缩，避免分割线被压成 0 */
  .download-page .section-inner * {
    flex-shrink: 0;
  }

  /* 模块一 */

  /* 预留固定导航栏高度 */
  .module-hero .mod1-layout {
    justify-content: flex-start;
    padding-top: 76px;
  }

  .module-hero .mod1-text {
    position: static;
    align-items: center;
    padding: 0 6%;
    text-align: center;
  }

  .module-hero .mod1-title {
    font-size: 9vw;
  }

  .module-hero .mod1-subtitle {
    font-size: 7vw;
    margin-top: 1vh;
  }

  .module-hero .mod1-desc {
    font-size: 5vw;
    line-height: 1.2;
    max-width: none;
    margin: 2vh 0 0 0;
    text-align: justify;
  }

  :lang(en) .module-hero .mod1-subtitle {
    font-size: 5vw;
  }

  :lang(en) .module-hero .mod1-desc {
    font-size: 4vw;
    transform: none;
  }

  /* 二维码改为底部下载按钮 */
  .module-hero .mod1-chapp,
  .module-hero .mod1-chapp-tip {
    display: none;
  }

  /* 底部下载按钮 */
  .module-hero .mod1-download-btn {
    position: absolute;
    left: 50%;
    bottom: 2vh;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88%;
    padding: 1.8vh 0;
    background: #00ADBB;
    color: #FFFFFF;
    border-radius: 100px;
    font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
    font-size: 4.5vw;
    font-weight: 500;
    text-decoration: none;
  }

  /* 右侧手机图 */
  .module-hero .mod1-phone {
    position: static;
    height: 62vh;
    width: auto;
    margin-left: 30vw;
    transform: none;
  }

  :lang(en) .module-hero .mod1-phone {
    height: 60vh;
    margin-left: 30vw;
  }

  /* 入场动效基准，覆盖桌面居中位移 */
  .reveal-section .mod1-phone {
    transform: translateY(24px);
  }

  .reveal-section.is-visible .mod1-phone {
    transform: translateY(0);
  }

  /* 模块二 */
  .module-intro .mod2-layout {
    display: flex;
    flex-direction: column;
    padding: 8vh 2vw 0;
  }

  .module-intro .mod2-header {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    width: auto;
    text-align: left;
    margin-bottom: 4vh;
  }

  .module-intro .mod2-title {
    font-size: 5.33vw;
    margin: -3vh 0 1vh 0;
  }

  :lang(en) .module-intro .mod2-title {
    font-size: 4.1vw;
    margin: 3vh 0 1vh 0;
  }

  .module-intro .mod2-divider {
    width: 36vw;
    margin: 0 auto 1vh;
  }

  .module-intro .mod2-subtitle {
    font-size: 3.2vw;
    max-width: 80vw;
    white-space: normal;
  }

  :lang(en) .module-intro .mod2-subtitle {
    max-width: 90vw;
  }

  .module-intro .mod2-cols {
    display: flex;
    align-items: flex-start;
    gap: 2vh;
  }

  .module-intro .mod2-col-right {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2vh;
  }

  .module-intro .mod2-col-center {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .module-intro .mod2-phone {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    height: 50vh;
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }

  /* 覆盖桌面 absolute 定位 */
  .module-intro .mod2-text {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    font-size: 2.8vw;
    width: 100%;
    max-width: none;
    line-height: 1.5;
    white-space: normal;
    text-align: left;
    padding: 0 4%;
    color: #252525;
    background: transparent;
    border-radius: 0;
    opacity: 1 !important;   /* 覆盖桌面端动画 */
  }

  :lang(en) .module-intro .mod2-text {
    font-size: 2.6vw;
  }

  .module-intro .mod2-card-2,
  .module-intro .mod2-card-3 {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    width: auto;
    object-fit: contain;
  }

  .module-intro .mod2-card-2 { max-height: 35vw; }
  .module-intro .mod2-card-3 { max-height: 21vw; }

  /* 手机图动效，仅保留缩放 */
  .reveal-section .mod2-phone {
    opacity: 0;
    transform: scale(0.8);
  }

  .reveal-section.is-visible .mod2-phone {
    opacity: 1;
    transform: scale(1);
    transition: opacity 1.1s ease 0s,
      transform 1.1s ease 0s;
  }

  /* 右侧图文同步淡入 */
  .reveal-section .mod2-card-2,
  .reveal-section .mod2-text-2,
  .reveal-section .mod2-card-3,
  .reveal-section .mod2-text-3 {
    opacity: 0;
    transform: scale(0.8);
  }
  .reveal-section.is-visible .mod2-card-2,
  .reveal-section.is-visible .mod2-text-2,
  .reveal-section.is-visible .mod2-card-3,
  .reveal-section.is-visible .mod2-text-3 {
    opacity: 1;
    transform: scale(1);
    transition: opacity 1.1s ease 0s, transform 1.1s ease 0s;
  }

  /* 模块三 */
  .module-feature .mod3-layout {
    justify-content: flex-start;
    padding-top: 10vh;
    padding-bottom: 6vh;
    overflow-y: auto;
    /* 滚动链不传给页面，翻页由 App.vue 接管 */
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    box-sizing: border-box;
  }

  .module-feature .mod3-title {
    font-size: 6.4vw;
    margin: 2vh 0 2vh 0;
    text-align: center;
  }

  :lang(en) .module-feature .mod3-title {
    font-size: 5.5vw;
    margin: 2vh 0 2vh 0;
  }

  .module-feature .mod3-divider {
    width: 40vw;
    margin-bottom: 1vh;
  }

  .module-feature .mod3-subtitle {
    font-size: 4.27vw;
    max-width: none;
    padding: 0 6%;
    margin: 0 0 2vh 0;
    text-align: justify;
  }

  :lang(en) .module-feature .mod3-subtitle {
    font-size: 4.27vw;
    line-height: 1.3;
    margin: 0 0 2vh 0;
  }

  .module-feature .mod3-list {
    flex-direction: column;
    align-items: center;
    gap: 2vh;
    width: 100%;
  }

  .module-feature .mod3-card {
    width: 88%;
    height: 14vh;
    transition: height 0.3s ease;
  }

  .module-feature .mod3-card.active {
    width: 88%;
    height: 29vh;
  }

  .module-feature .mod3-card-title {
    left: 4vw;
    top: 1.5vh;
    font-size: 4.8vw;
    text-align: left;
  }

  :lang(en) .module-feature .mod3-card-title {
    font-size: 4.6vw;
    top: 1.5vh;
    left: 5vw;
  }
  .module-feature .mod3-card.active .mod3-card-title {
    left: 4vw;
    top: 1.5vh;
  }

  :lang(en) .module-feature .mod3-card.active .mod3-card-title {
    left: 5vw;
    top: 1.5vh;
  }

  .module-feature .mod3-card-subtitle {
    left: 4vw;
    top: 5.5vh;
    max-width: 70%;
    line-height: 1.3;
    font-size: 3.5vw;
  }

  .module-feature .mod3-card.active .mod3-card-subtitle {
    left: 4vw;
    text-align: left;
    max-width: 85%;
  }

  :lang(en) .module-feature .mod3-card-subtitle {
    left: 5vw;
    top: 5.3vh;
    max-width: 70%;
    font-size: 3.7vw;
  }

  :lang(en) .module-feature .mod3-card.active .mod3-card-subtitle {
    max-width: 85%;
    font-size: 3.7vw;
    left: 5vw;
  }

  /* 详情面板 */
  .module-feature .mod3-card:nth-child(1) .mod3-panel,
  .module-feature .mod3-card:nth-child(2) .mod3-panel,
  .module-feature .mod3-card:nth-child(3) .mod3-panel,
  .module-feature .mod3-card:nth-child(4) .mod3-panel {
    left: 4vw;
    top: 11vh;
    width: 40vw;
  }
  :lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel{
    left: 4vw;
    top: 11vh;
    width: 38vw;
  }
  :lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel,
  :lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
    left: 4vw;
    top: 11vh;
    width: 40vw;
  }

  /* 小图与小字间距 */
  .module-feature .mod3-card:nth-child(1) .mod3-panel {
    top: 10vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(1) .mod3-panel {
    top: 13vh;
  }

  .module-feature .mod3-card:nth-child(2) .mod3-panel {
    top: 12vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(2) .mod3-panel {
    top: 14vh;
  }

  .module-feature .mod3-card:nth-child(3) .mod3-panel {
    top: 12vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(3) .mod3-panel {
    top: 14vh;
  }

  .module-feature .mod3-card:nth-child(4) .mod3-panel {
    top: 10vh;
  }

  :lang(en) .module-feature .mod3-card:nth-child(4) .mod3-panel {
    top: 9vh;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-section .section-inner {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
</style>
